import { Route, Switch } from 'react-router-dom';
// @ts-ignore
import { GlobalProvider } from 'legacyfrontend/contexts/GlobalContext';
// @ts-ignore
import { CacheConfigProvider } from 'legacyfrontend/contexts/CacheConfigContext';
// @ts-ignore
import { PackageCacheProvider } from 'legacyfrontend/contexts/PackageCacheContext';
import Map from './legacyfrontend/components/agencies/agencies';
import { withSessionStorageCheck } from './legacyfrontend/helpers/withSessionStorageCheck';
import routes from './legacyfrontend/routes';
import { useAppName } from './legacyfrontend/hooks/useSafeState';
import { useClientTenantSync } from 'core/hooks/useClientTenantSync';
import { useGoogleTagManager } from './legacyfrontend/hooks/useGoogleTagManager';
import { useTranslation } from 'react-i18next';
import { Seo } from 'core/components/seo';
import './fonts/Montserrat-Variable.ttf';

// Type for route objects
interface RouteType {
  path: string;
  name?: string;
  [key: string]: any;
}

function App() {
  const appName = useAppName();
  useClientTenantSync();
  useGoogleTagManager();
  const { i18n } = useTranslation();

  return (
    <>
      <Seo
        description={`${appName} — Reservá tus vacaciones y paquetes turísticos con los mejores precios y financiación.`}
        language={i18n.language || 'es'}
        title={appName}
      >
        <meta charSet='utf-8' />
      </Seo>
      <Switch>
        <Route
          path='/agencies-iframe'
          // eslint-disable-next-line react/jsx-no-bind
          render={() => <Map />}
        />
        <GlobalProvider>
          <CacheConfigProvider>
            <PackageCacheProvider>
              <Switch>
                {routes.map((route: RouteType) => (
                  <Route key={`${route.path}-${route.name || 'unnamed'}`} {...route} />
                ))}
              </Switch>
            </PackageCacheProvider>
          </CacheConfigProvider>
        </GlobalProvider>
      </Switch>
    </>
  );
}

export default withSessionStorageCheck(App);
